import { Button, Drawer, Space } from "antd";
import moment from "moment";
import { AiOutlineClose } from "react-icons/ai";
import DateLine from "../../../components/shared/DateLine";
import formatMoney from "../../../utils/formatMoney";

export default function ServicePanel({
  isVisible,
  setShowDetails,
  selected,
  startDate,
  endDate,
}: any) {
  return (
    <Drawer
      title={
        <div className="flex items-center">
          <span className="mr-2 text-lg">
            {selected === undefined ? "Service" : selected?._id?.service} :
          </span>
          <DateLine startDate={startDate} endDate={endDate} />
        </div>
      }
      placement={"right"}
      width={800}
      onClose={() => setShowDetails(!isVisible)}
      visible={isVisible}
      closable={false}
      extra={
        <Space>
          <Button
            type="default"
            color="#E50000"
            onClick={() => setShowDetails(!isVisible)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      <div className="font-toyota">
        <div className="flex py-1 border-b border-gray-300">
          <div className="mr-2 w-10 text-center font-bold">S/N.</div>
          <div className="flex justify-between items-center flex-1">
            <div className="flex items-center">
              <div className="w-24 font-bold">Vehicle</div>
              <div className="w-40 truncate font-bold">Customer</div>
              <div className="w-28 font-bold">Service details</div>
              <div className="w-36 font-bold">Service date</div>
              <div className="w-16 font-bold">WIP</div>
            </div>
            <div className="font-bold text-center">Invoice Value</div>
          </div>
        </div>
        {selected?.list?.map((item: any, index: number) => (
          <div className="flex py-1 border-b border-gray-300" key={index}>
            <div className="mr-2 w-10 text-center">{index + 1}.</div>
            <div className="flex justify-between items-center flex-1">
              <div className="flex items-center">
                <div className="w-24 truncate">{item?.registration}</div>
                <div className="w-40 truncate">
                  {item.customer === " " ? "-" : item.customer}
                </div>
                <div className="w-28 truncate">{item?.service_details}</div>
                <div className="w-36 truncate text-left">
                  {item?.service_date === null ? (
                    "-"
                  ) : (
                    <span>
                      {moment(item?.service_date.toString()).format(
                        "Do MMM YYYY"
                      )}
                    </span>
                  )}
                </div>
                <div className="w-16 truncate text-left">{item?.wip}</div>
              </div>
              <div className="">
                {item?.invoice_value === 0
                  ? formatMoney(0)
                  : formatMoney(item?.invoice_value)}
              </div>
            </div>
          </div>
        ))}
        <div className="flex justify-between items-start border-t-2 border-b-2 py-2">
          <div className="font-bold"></div>
          <div className="font-bold">
            {selected === undefined
              ? formatMoney(0)
              : formatMoney(selected?.invoice_value)}
          </div>
        </div>
      </div>
    </Drawer>
  );
}
